import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, catchError } from "rxjs/operators";
import {ErrorHandlerService} from './error-handler.service';
import { apiLinks } from 'src/app/core/api-links/api-links';

@Injectable({
  providedIn: 'root'
})
export class DownloadlogService {

  constructor(
    private handleError:ErrorHandlerService,
    private httpClient: HttpClient
  ) { }

  getAllDownloadLog(params) {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('sort', '{"field": "updatedAt", "order":"DESC"}')
    httpParams = httpParams.append('size', '20');
    Object.keys(params).forEach(function(key) {
      httpParams = httpParams.append(key, params[key]);
    })
    return this.httpClient.get(apiLinks.getAllDownloadLogs , {params: httpParams}).pipe(
      map((res: any) => {
        return res;
      }),
      catchError(this.handleError.handleError)
    );
  }

  getMoreDownloadLog(httpReqUrl, parameter, params) {
    let httpParams = new HttpParams();
    httpReqUrl = httpReqUrl+parameter.manufacturerId+"/"+parameter.deviceModelId+"/"+parameter.tpn;
    Object.keys(params).forEach(function(key) {
      httpParams = httpParams.append(key, params[key]);
    })
    return this.httpClient.get(httpReqUrl,{params:httpParams}).pipe(
      map((res: any) => {
        return res.data;
      }),
      catchError(this.handleError.handleError)
    );
  }

}
